import { AbstractControl } from '@angular/forms';
import { NgxMatIntlTelInputComponent } from 'ngx-mat-intl-tel-input';

// The library (ngx-mat-intl-tel-input) blocks typed non-digit characters but does not intercept paste events.
// Pasting invalid characters causes AsYouType to strip them silently, leaving the DOM
// input empty while the field saves as an empty string without any validation error.
// This handler rejects pastes containing non-phone characters before they reach the library.
export function preventInvalidPhonePaste(event: ClipboardEvent): void {
  const pasted = event.clipboardData?.getData('text/plain') ?? '';
  // Allow: digits, +, -, (, ), space, .
  if (!/^[\d+\-().\s]+$/.test(pasted)) {
    event.preventDefault();
  }
}

// Library bug: when input cannot be parsed (e.g. a single digit), the library sets control.value to undefined
// and its validator skips the check, treating it as empty (valid). If the user typed something
// but the control value is still empty, mark the control invalid.
export function applyUnparsedPhoneInputValidation(
  phoneInput: NgxMatIntlTelInputComponent | undefined,
  control: AbstractControl,
): void {
  const hasInput = !!phoneInput?.phoneNumber;
  const isParsed = !!control.value;
  if (hasInput && !isParsed) {
    control.setErrors({ validatePhoneNumber: true });
  }
}
